<app-eca-modal-host [heading]="headerText" (saveClicked)="saveClicked()"
                    (cancelClicked)="cancelBtnClicked()"
                    [isEditing]="!isEditing"
                    [yesButtonIcon]="['far', 'save']"
                    [noButtonIcon]="['far', 'times']"
                    noButtonColour="transparent">
  <div *ngIf="isEmailModalLoading" class="text-center">
    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
  </div>
  <div *ngIf="!isEmailModalLoading" class="container">
    <div *ngFor="let option of emailOptions" class="row">
      <app-eca-checkbox label="{{option.name}} - {{option.email}}" inputId="{{option.email}}" [(value)]="option.selected">
      </app-eca-checkbox>
    </div>
  </div>
</app-eca-modal-host>
